import React, { useState } from 'react';
import { InstagramIcon, LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function EditorialContact() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    if (!data.get('Nombre completo') || !data.get('Correo electrónico') || !data.get('Mensaje')) {
      setError('Completá nombre, email y mensaje para enviarnos tu consulta.');
      return;
    }
    setError('');
    try {
      const response = await fetch('https://formsubmit.co/ajax/arq.vcorbalan@gmail.com', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: data
      });
      if (!response.ok) {
        throw new Error('No se pudo enviar el formulario.');
      }
      setSent(true);
      e.currentTarget.reset();
    } catch {
      setError('Hubo un error al enviar el mensaje. Por favor, intentá de nuevo.');
    }
  };
  return <>
      <section id="contacto" className="grid lg:grid-cols-2" data-id="element-64" data-mp="1pvqlqlecgirh">
        <div className="bg-[#1A1A1A] px-7 py-20 text-white md:px-16 lg:px-24" data-id="element-65" data-mp="24rg140p0xxn8">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#d88b67]" data-id="element-66" data-mp="24pd1coy2kq5b">
            Contacto
          </p>
          <h2 className="font-editorial mt-5 max-w-md text-5xl leading-tight" data-id="element-67" data-mp="2drw0oz2nckmt">
            ¿Tenés un proyecto en mente?
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-7 text-white/65" data-id="element-68" data-mp="28sjfsjvc5nmv">
            Contame tu idea. La primera consulta es sin cargo.
          </p>
          <div className="mt-12 space-y-5 text-sm text-white/80" data-id="element-69" data-mp="2ij485pkf1vxc">
            <p className="flex gap-3" data-id="element-70" data-mp="2ijw5p5xkq3q9">
              <MailIcon size={18} className="text-[#C4724A]" data-id="element-71" data-mp="2wim36mob25f5" />
              arq.vcorbalan@gmail.com
            </p>
            <p className="flex gap-3" data-id="element-72" data-mp="2si3a6paoetbd">
              <PhoneIcon size={18} className="text-[#C4724A]" data-id="element-73" data-mp="2sj4y3ucsjaai" />
              +598 95 285 003
            </p>
            <a href="https://www.instagram.com/vcestudiouy/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noreferrer" className="flex w-fit gap-3 transition-colors hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#d88b67]" data-id="element-74" data-mp="2zidv1qtwgmvt">
              <InstagramIcon size={18} className="text-[#C4724A]" data-id="element-75" data-mp="3ia6pzqsj4i66" />
              @vcestudiouy
            </a>
            <p className="flex gap-3" data-id="element-76" data-mp="3n885k1qqxzcw">
              <MapPinIcon size={18} className="text-[#C4724A]" data-id="element-77" data-mp="3s9fdc0sw2yjk" />
              Montevideo, Uruguay
            </p>
          </div>
        </div>
        <div className="bg-[#F7F4EF] px-7 py-20 md:px-16 lg:px-24" data-id="element-78" data-mp="11jpx2bpxl5g">
          <h2 className="font-editorial text-3xl" data-id="element-79" data-mp="1xvo617y18qra">Hablemos de tu idea</h2>
          {sent && <p role="status" className="mt-5 bg-[#e5eee2] p-4 text-sm text-[#405238]" data-id="element-80" data-mp="22tpp3svgkq2r">
              Gracias por escribir. Te responderemos a la brevedad.
            </p>}
          {error && <p role="alert" className="mt-5 text-sm text-[#a34d31]" data-id="element-81" data-mp="f73ii9by8i69">
              {error}
            </p>}
          <form noValidate onSubmit={submit} className="mt-6 grid gap-5" data-id="element-82" data-mp="b4ow5f92n0a8">
            <input type="hidden" name="_subject" value="Nueva consulta desde VC Estudio" data-id="element-83" data-mp="699q39hb28od" />
            <label className="text-xs font-bold" data-id="element-84" data-mp="12wo5d3b83zkt">
              Nombre completo
              <input name="Nombre completo" className="input-field" data-id="element-85" data-mp="yw42rk7vs3ra" />
            </label>
            <label className="text-xs font-bold" data-id="element-86" data-mp="twrh32sqx2qa">
              Email
              <input name="Correo electrónico" type="email" className="input-field" data-id="element-87" data-mp="oy6jlb4vox5j" />
            </label>
            <label className="text-xs font-bold" data-id="element-88" data-mp="3eniahu9obt5g">
              Teléfono <span className="font-normal" data-id="element-89" data-mp="3ep31xb0oyvz3">(opcional)</span>
              <input name="Teléfono" className="input-field" data-id="element-90" data-mp="39o5ofbqmmq3x" />
            </label>
            <label className="text-xs font-bold" data-id="element-91" data-mp="11fz77ap0vn62">
              Tipo de proyecto
              <select name="Tipo de proyecto" className="input-field" data-id="element-92" data-mp="11dw5vuif67m1">
                <option data-id="element-93" data-mp="1680hir2mr3tg">Vivienda</option>
                <option data-id="element-94" data-mp="sfarmbjzder2">Reforma</option>
                <option data-id="element-95" data-mp="sgc32h4ws39b">Local</option>
                <option data-id="element-96" data-mp="sd7rgyp4658m">Interiores</option>
                <option data-id="element-97" data-mp="xdcc90x21m4n">Otro</option>
              </select>
            </label>
            <label className="text-xs font-bold" data-id="element-98" data-mp="1l3zlpqmmcjtb">
              Mensaje
              <textarea name="Mensaje" rows={3} className="input-field resize-none" placeholder="Contame un poco sobre tu idea..." data-id="element-99" data-mp="1l1lu5rr5dpqi" />
            </label>
            <button className="mt-3 bg-[#C4724A] py-4 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#a95d3b]" data-id="element-100" data-mp="1g4dafmqcpdn5">
              Enviar consulta
            </button>
          </form>
        </div>
      </section>
      <footer className="bg-[#1A1A1A] px-5 py-12 text-white md:px-10" data-id="element-101" data-mp="4qhqm0oi4gpl">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-8 md:flex-row md:items-center md:justify-between" data-id="element-102" data-mp="3tb33jng4evtb">
          <div data-id="element-103" data-mp="3od1i4vv82keo">
            <p className="font-editorial text-2xl" data-id="element-104" data-mp="3obgnz7ctl3hc">VC Estudio</p>
            <p className="mt-2 text-xs text-white/50" data-id="element-105" data-mp="66djnouogvhz">
              Arquitectura que transforma formas de vivir.
            </p>
          </div>
          <nav className="flex gap-5 text-xs text-white/70" data-id="element-106" data-mp="182550tftwtf">
            <a href="#inicio" data-id="element-107" data-mp="39mu894ja69pl">Inicio</a>
            <a href="#proyectos" data-id="element-108" data-mp="39nvpxrusxuga">Proyectos</a>
            <a href="#contacto" data-id="element-109" data-mp="35m0o8m8ylf1z">Contacto</a>
          </nav>
          <div className="flex gap-4" data-id="element-110" data-mp="35nlhm8jjery9">
            <InstagramIcon size={18} data-id="element-111" data-mp="3jcvqhfoycxwl" />
            <LinkedinIcon size={18} data-id="element-112" data-mp="3jdxboczon0s1" />
          </div>
        </div>
        <div className="mx-auto mt-10 flex max-w-[1440px] justify-between border-t border-white/15 pt-5 text-[10px] text-white/40" data-id="element-113" data-mp="3elx3xyddf3kw">
          <span data-id="element-114" data-mp="2qvjk2v4xwb1e">© 2025 María Victoria Corbalan</span>
          <span data-id="element-115" data-mp="2ly1ar3n0ftsv">Diseñado con intención</span>
        </div>
      </footer>
    </>;
}